import React from 'react';
import { Dialog, IconButton, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { ModalPaper } from '@europrocurement/l2d-modules';
import AddLegalAnnoucementForm, {
    AddLegalAnnoucementFormData,
} from '../AddLegalAnnoucementForm/AddLegalAnnoucementForm';

export type AddLegalAnnoucementModalProps = {
    showModal: boolean;
    processing: boolean;
    onClose: () => void;
    onSubmit: (data: AddLegalAnnoucementFormData) => void;
};

const AddLegalAnnoucementModal: React.FunctionComponent<AddLegalAnnoucementModalProps> = function (
    props,
) {
    const { showModal, processing, onClose, onSubmit } = props;
    const { palette } = useTheme();

    return (
        <Dialog
            open={showModal}
            PaperComponent={ModalPaper}
        >
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    fontSize: '16px',
                    position: 'absolute',
                    right: '20px',
                    top: '30px',
                    color: palette.grey[500],
                }}
            >
                <FaOptionIcon icon={['fas', 'close']} />
            </IconButton>
            <AddLegalAnnoucementForm
                processing={processing}
                onSubmit={onSubmit}
                onCancel={onClose}
            />
        </Dialog>
    );
};

export default AddLegalAnnoucementModal;
